import { AvField, AvForm } from "availity-reactstrap-validation";
import { withNamespaces } from "react-i18next";
import { Col, Label, Row } from "reactstrap";
import ButtonsGroup from "../ButtonsGroup";

const ReferenceNumber = ({ t, onValidSubmit, onBackClicked, prevData }) => {
    return (
        <AvForm 
            onValidSubmit={(_e, values) => {
                onValidSubmit(values)
            }} 
            className="needs-validation"
        >
            <Row className="mb-3">
                <Col sm='12' md='6'>
                    <Label for="ddsReferenceNumber">
                        {t("DDS Reference Number")} <span className="text-danger">*</span>
                    </Label>
                    <AvField
                        name="ddsReferenceNumber"
                        type="text"
                        errorMessage={t("This field cannot be blank")}
                        className="form-control"
                        validate={{
                            required: { value: true }
                        }}
                        id="ddsReferenceNumber"
                        defaultValue={prevData?.ddsReferenceNumber}
                    />
                </Col>
            </Row>

            <Row>
                <Col sm='12' md='6'>
                    <Label for="ddsVerificationNumber">
                        {t("DDS Verification Number")} <span className="text-danger">*</span>
                    </Label>
                    <AvField
                        name="ddsVerificationNumber"
                        type="text"
                        errorMessage={t("This field cannot be blank")}
                        className="form-control"
                        validate={{
                            required: { value: true }
                        }}
                        id="ddsVerificationNumber"
                        defaultValue={prevData?.ddsVerificationNumber}
                    />
                </Col>
            </Row>

            <ButtonsGroup
                onBackClicked={onBackClicked}
                onNextClicked={() => {}}
                nextButtonType='submit'
            />
        </AvForm>
    )
};

export default withNamespaces()(
    ReferenceNumber
);